<template>
  <div class="container-content mb-4">
    <div class="tile-content-header">
      <h3 class="text-uppercase">
        {{ $t('invoices.tracking.dhlNumber') }}
      </h3>
      <small class="text-uppercase"><b-icon-hash /> {{ dhlNumber }} </small>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dhlNumber'],
  mounted() {
    this.$mpTrack('Invoice details - DHLTracking component rendered')
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/variables';
.container-content {
  position: relative;
  .tile-content-header {
    padding: 1rem 2rem;
    background: $dc-actions-bg;
    border-bottom: 1px solid $drip-border-color;
    font-family: $montserrat;
    h3 {
      letter-spacing: 0.6px;
      font-weight: bold;
      color: $dc-input-color;
      font-size: 1rem;
      line-height: 1.5;
    }
  }
}
</style>
